import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation,
    ChangeDetectionStrategy, ElementRef, NgZone, ChangeDetectorRef
} from "@angular/core";

// import { scaleBand, scaleLinear } from "d3-scale";
// https://github.com/d3/d3/blob/5f0bea71c6f0c1928fbb0394def13641b38a3e4b/CHANGES.md
import * as d3 from "d3";
import { calculateViewDimensions, ViewDimensions } from "../../common/view-dimensions.helper";
import { ColorHelper } from "../../common/color.helper";
import { NgBaseChartComponent } from "../../common/base-chart.component";
import { LocationStrategy } from "@angular/common";

@Component({
    selector: "ng-bar-chart",
    templateUrl: "./ng-bar-chart.component.html",
    styleUrls: ["./ng-bar-chart.component.less"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class NgBarChartComponent extends NgBaseChartComponent {
    @Input() tooltips: string;
    @Input() barChartBackgroundColor: string;
    @Input() barPercentage: number;
    @Input() barBackgroundColor: string;

    @Input() legend = false;
    @Input() yAxis;
    @Input() showXAxisLabel;
    @Input() showYAxisLabel;
    @Input() xAxisLabel;
    @Input() yAxisLabel;
    @Input() tooltipDisabled = false;
    @Input() gradient: boolean;
    @Input() showGridLines = true;
    @Input() activeEntries: any[] = [];
    @Input() schemeType: string;
    @Input() xAxisTickFormatting: any;
    @Input() yAxisTickFormatting: any;
    @Input() barPadding = 8;
    @Input() roundDomains = false;

    @Output() activate: EventEmitter<any> = new EventEmitter();
    @Output() deactivate: EventEmitter<any> = new EventEmitter();

    dims: ViewDimensions;
    yScale: any;
    xScale: any;
    xDomain: any;
    yDomain: any;
    transform: string;
    colors: ColorHelper;
    margin = [10, 20, 10, 20];
    xAxisHeight = 0;
    yAxisWidth = 0;
    legendOptions: any;

    constructor(
        public chartElement: ElementRef,
        public zone: NgZone,
        public cd: ChangeDetectorRef,
        public location: LocationStrategy) {
        super(chartElement, zone, cd, location);
    }

    update(): void {
        super.update();
    }

    onClick(data): void {
        console.log("ng-bar-chart: onClick");
    }

    onActivate(item) {
        console.log("ng-bar-chart: onActivate");
    }

    onDeactivate(item) {
        console.log("ng-bar-chart: onDeactivate");
    }

}
